import { Component, ComponentInterface, Element, h, Host, Listen, State } from '@stencil/core';
import { addEventListener, removeEventListener } from '../../utils/helpers';

@Component({
  tag: 'vds-header-slides',
  styleUrl: 'vds-header-slides.scss',
  shadow: true,
})
export class VdsHeaderSlides implements ComponentInterface {

  private desktopMediaQuery = `(min-width: ${getComputedStyle(document.documentElement).getPropertyValue('--vt-breakpoint-sm').trim()})`;
  private separatorImg = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjAuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkViZW5lXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxNjQuNCA0MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2NC40IDQxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNGRkVEMDA7fQoJLnN0MXtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8ZyBpZD0iRWJlbmVfMV8xXyI+Cgk8cG9seWdvbiBjbGFzcz0ic3QwIiBwb2ludHM9IjQsMCAxLjUsNDEyIDkuNSw0MTIgMTU5LjYsMCAJIi8+CjwvZz4KPGcgaWQ9IkViZW5lXzJfMV8iPgoJPHBvbHlnb24gY2xhc3M9InN0MSIgcG9pbnRzPSIwLDAgMCw0MTIgMS41LDQxMiAxNTEuNiwwIAkiLz4KPC9nPgo8L3N2Zz4K';

  @Element() el!: HTMLElement;

  @State() contentSlides?: HTMLVdsSlidesElement;
  @State() mediaSlides?: HTMLVdsSlidesElement;
  @State() matches = window.matchMedia(this.desktopMediaQuery).matches;

  @Listen('resize', { target: 'window' })
  handleResize() {
    const matches = window.matchMedia(this.desktopMediaQuery).matches;
    if (this.matches !== matches) {
      this.matches = window.matchMedia(this.desktopMediaQuery).matches;
    }
  }

  async componentDidRender(): Promise<void> {
    this.mediaSlides = this.el.querySelector('vds-slides[slot=media]');
    this.contentSlides = this.el.querySelector('vds-slides[slot=content]');

    if (this.mediaSlides && this.contentSlides) {
      this.mediaSlides.options.effect = 'fade';
      this.mediaSlides.options.centeredSlides = true;
      await this.mediaSlides.update();
      await this.contentSlides.lockSwipes(true);
      addEventListener(this.mediaSlides, 'vdsSlideDidChange', () => this.changeContentSlide(this.mediaSlides, this.contentSlides));
    }
  }

  disconnectedCallback(): void {
    if (this.mediaSlides) {
      removeEventListener(this.mediaSlides, 'vdsSlideDidChange', () => this.changeContentSlide(this.mediaSlides, this.contentSlides));
    }
  }

  render() {
    const { separatorImg, matches, mediaSlides, contentSlides } = this;

    matches ?
      contentSlides?.classList.add('swiper-horizontal-centered') :
      contentSlides?.classList.remove('swiper-horizontal-centered');

    return (
      <Host>
        <div class="relative flex flex-wrap overflow-hidden shadow-[-1px_1px_4px_rgb(237,237,236)] sm:rounded-b-[8px] my-[2px] sm:ml-[2px] ml-[-30px] sm:w-full w-[calc(100%+60px)]">

          { matches && (
            <div class="relative flex items-center bg-white sm:max-w-[39.2%] max-w-full flex-1 sm:w-1/2 sm:pl-[30px] lg:pl-[50px] sm:mt-0 mt-[30px] sm:order-none order-2">
              <div class="block w-full max-w-full h-full">
                <div id="contentDesktopContainer" class="relative grid items-center h-full min-h-auto z-0 overflow-hidden">
                  <slot name="content"></slot>
                </div>
              </div>
              <div>
                <img class="separator" src={ separatorImg } alt="separator" />
              </div>
            </div>
          )}

          <div class="sm:w-1/2 flex-1 max-w-full">
            <div class="relative h-full text-[rgba(255, 255, 255, 0.7)]">
              <div class="relative z-0 overflow-hidden h-full box-border">
                  <slot name="media"></slot>
              </div>
            </div>
          </div>
        </div>
        <div class="grid justify-items-end pt-[20px]">
          {
            mediaSlides && (<vds-pagination-pill slides={mediaSlides}></vds-pagination-pill>)
          }
        </div>
        <div id="contentMobileContainer" class="block sm:hidden mt-10 sm:mt-0">
          {
            !matches && (<slot name="content"></slot>)
          }
        </div>
      </Host>
    );
  }

  private async changeContentSlide(mediaSlides: HTMLVdsSlidesElement, contentSlides: HTMLVdsSlidesElement): Promise<void> {
    const index = await mediaSlides.getActiveIndex();
    await contentSlides.slideTo(index);
  }

}
